import dayjs from 'dayjs'
import { changeTimeLocalToUtc } from '../../../helper'
import { DATE_FORMAT } from '../../../utils/constants'

class TradeNdf {
  constructor(form) {
    this.trade_type = form.trade_type.name
    if (form.trade_type.name.includes('Client') && form.side) {
      this.side = form.side === 'BUY' ? 'SELL' : 'BUY'
    } else {
      this.side = form.side
    }
    this.price = Number(form.price)
    this.base_currency = form.currency_pair.substring(0, 3)
    this.counter_currency = form.currency_pair.substring(3, 6)
    this.counterparty = form.counterparty
    this.trade_date = changeTimeLocalToUtc(form.trade_date, DATE_FORMAT.REGULAR_DATE_TIME)
    this.value_date = form.value_date ? dayjs(form.value_date).format(DATE_FORMAT.REGULAR_DATE) : ''
    this.quantity = Number(form.quantity)
    this.fixing_date = form.fixing_date
      ? dayjs(form.fixing_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.fixing_source = form.fixing_source
    this.note = form.note
    this.direction = form.direction
    this.trade_origin = 'FXER'
  }
  // will work just when update
  isEqual(trade) {
    let { trade_date, value_date } = trade
    trade_date = dayjs(trade_date).format(DATE_FORMAT.REGULAR_DATE_TIME)
    value_date = dayjs(value_date).format(DATE_FORMAT.REGULAR_DATE)
    trade.trade_type = trade.type
    trade.price = trade.client_price || trade.market_maker_price
    trade.quantity = Math.abs(trade.client_quantity) || Math.abs(trade.market_maker_quantity)
    trade.counterparty = trade.client || trade.market_maker
    trade = new TradeNdf(trade)
    trade.trade_date = trade_date
    trade.value_date = value_date
    for (const key of Object.keys(trade)) {
      if (this[key] !== trade[key]) {
        return false
      }
    }

    delete trade.trade_date
    return true
  }
}

export default TradeNdf
